// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".phone-icon[data-v-0399ba5c]{color:#5456ff}.consultant-name[data-v-0399ba5c]{color:dimgray;font-size:12px;font-weight:600}.contact-phone[data-v-0399ba5c]{font-weight:600}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
